import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WebConfig } from '@ctt-babylon/public-api';
import { catchError, filter, first, tap, throwError } from 'rxjs';
import { ApiService } from '../api/api.service';
import { RoutesService } from '../routes/routes.service';
import { SiteConfigService } from '../site-config/site-config.service';

@Injectable({
    providedIn: 'root',
})
export class InitializerService {

    constructor(
        private readonly siteSvc: SiteConfigService,
        private readonly routesSvc: RoutesService,
        private readonly apiService: ApiService
    ) {}

    loadSettings(): Promise<void> {
        return this.getAndManageGeneralConfig();
    }

    async configureRoutes(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.apiService
                .getRoutes()
                .pipe(
                    filter((data) => data !== null && data !== undefined),
                    first(),
                    tap((data) => {
                        this.routesSvc.setSettingsRouter((data as any).pages);
                        resolve();
                    }),
                    catchError((err) => {
                        reject(err);
                        return throwError(() => err);
                    })
                )
                .subscribe();
        });
    }

    async getAndManageGeneralConfig(): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            this.siteSvc
                .getGeneralConfig()
                .pipe(
                    filter((body): body is WebConfig => body !== null),
                    first(),
                    tap((config) => {
                        this.siteSvc.setInitialLanguage(config);
                        this.routesSvc.setSettingsRouter(config.pages);

                        if (!this.siteSvc.cdnImagesInstant) {
                            this.siteSvc.setCdnImages(config.cdn || '');
                        }
                        this.siteSvc.setWebConfig(config);
                        resolve();
                    }),
                    catchError((err: HttpErrorResponse) => {
                        reject(err);
                        return throwError(() => err);
                    })
                )
                .subscribe();
        });
    }
}
